var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _g3, _path8, _path9, _path10, _path11, _path12, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElephant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 205,
    viewBox: "0 0 192 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 0C113.612 0 91 22.6197 91 50.5C91 78.3966 113.612 101 141.5 101C169.388 101 192 78.3966 192 50.5C192 22.6197 169.388 0 141.5 0ZM141.5 22.3992C146.223 22.3992 150.052 26.2282 150.052 30.9516C150.052 35.675 146.223 39.504 141.5 39.504C136.777 39.504 132.948 35.675 132.948 30.9516C132.948 26.2282 136.777 22.3992 141.5 22.3992ZM152.903 74.121C152.903 75.4704 151.809 76.5645 150.46 76.5645H132.54C131.191 76.5645 130.097 75.4704 130.097 74.121V69.2339C130.097 67.8844 131.191 66.7903 132.54 66.7903H134.984V53.7581H132.54C131.191 53.7581 130.097 52.664 130.097 51.3145V46.4274C130.097 45.078 131.191 43.9839 132.54 43.9839H145.573C146.922 43.9839 148.016 45.078 148.016 46.4274V66.7903H150.46C151.809 66.7903 152.903 67.8844 152.903 69.2339V74.121Z",
    fill: "#F4EFFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.615 142.661C34.455 166.641 55.805 193.471 82.355 193.651C108.915 193.831 130.625 167.301 130.785 143.311C130.945 119.331 109.505 106.971 82.945 106.791C56.385 106.611 34.775 118.671 34.605 142.651L34.615 142.661Z",
    fill: "url(#paint0_linear_0_1)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.282 118.82L117.273 118.824C112.282 121.314 110.254 127.379 112.743 132.371L125.014 156.97C127.504 161.962 133.568 163.99 138.56 161.5L138.569 161.496C143.56 159.006 145.589 152.941 143.099 147.949L130.829 123.35C128.339 118.358 122.274 116.33 117.282 118.82Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2106 104.283L15.2023 104.289C10.5551 107.374 9.28888 113.642 12.3741 118.289L31.5722 147.207C34.6575 151.854 40.9258 153.12 45.573 150.035L45.5813 150.029C50.2285 146.944 51.4947 140.676 48.4095 136.029L29.2114 107.111C26.1261 102.464 19.8578 101.198 15.2106 104.283Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.305 46.331L35.275 36.571C30.375 33.581 24.215 33.561 19.295 36.521C10.985 41.501 4.73497 49.291 1.67497 58.481C-3.40503 73.711 3.39497 90.361 17.675 97.681L33.555 105.821L51.295 46.331H51.305Z",
    fill: "#9E83FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.305 55.3611L34.975 47.2511C30.895 44.7711 25.775 44.7511 21.685 47.2111C14.785 51.3511 9.58497 57.8311 7.04497 65.4611C2.82497 78.1211 8.47497 91.9611 20.355 98.0511L33.555 104.821L48.305 55.3611Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.005 46.331L123.035 36.571C127.935 33.581 134.095 33.561 139.015 36.521C147.315 41.501 153.565 49.291 156.625 58.471C161.705 73.701 154.905 90.351 140.625 97.671L124.745 105.811L107.005 46.321V46.331Z",
    fill: "#9E83FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.005 55.3611L123.335 47.2511C127.415 44.7711 132.535 44.7511 136.625 47.2111C143.525 51.3511 148.725 57.8311 151.265 65.4611C155.485 78.1211 149.835 91.9611 137.955 98.0511L124.755 104.821L110.005 55.3611Z",
    fill: "url(#paint4_linear_0_1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.655 93.601C132.655 123.151 108.705 136.401 79.155 136.401C49.605 136.401 25.655 123.151 25.655 93.601C25.655 64.051 58.635 32.321 79.155 32.321C99.675 32.321 132.655 64.051 132.655 93.601Z",
    fill: "url(#paint5_linear_0_1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.765 36.1311C72.485 39.7511 72.565 50.2911 72.565 50.2911C72.675 50.6511 73.185 50.5311 73.355 50.4211C74.085 49.9511 75.765 47.9011 75.765 47.9011C75.975 47.6011 76.425 47.6711 76.545 48.0111C76.545 48.0111 77.655 51.8311 77.905 55.2611C77.925 55.4811 78.585 55.3611 78.755 55.2411C80.345 54.0911 81.685 47.7811 81.685 47.7811C81.785 47.4311 82.225 47.3411 82.455 47.6111C82.455 47.6111 84.255 48.4311 85.195 50.8911C85.265 51.0811 85.825 50.8311 85.975 50.6911C88.965 47.9511 90.785 37.5711 88.545 34.3411C85.365 29.7511 63.385 32.7611 67.765 36.1211V36.1311Z",
    fill: "#8058EA"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.155 82.321C93.405 77.071 101.905 77.071 107.155 82.321",
    stroke: "#474193",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.115 108.001L96.015 107.751C103.425 105.721 110.035 101.471 114.955 95.571C116.085 94.221 118.245 94.621 118.815 96.281C120.685 101.711 122.085 110.351 115.595 115.091C105.765 122.281 97.385 115.221 94.045 111.701C92.875 110.471 93.465 108.441 95.105 107.991L95.115 108.001Z",
    fill: "#FFFFFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.545 100.261C67.1054 100.261 74.045 91.3068 74.045 80.2611C74.045 69.2154 67.1054 60.2611 58.545 60.2611C49.9846 60.2611 43.045 69.2154 43.045 80.2611C43.045 91.3068 49.9846 100.261 58.545 100.261Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.545 78.701C69.545 74.8351 66.411 71.701 62.545 71.701C58.679 71.701 55.545 74.8351 55.545 78.701V85.701C55.545 89.567 58.679 92.701 62.545 92.701C66.411 92.701 69.545 89.567 69.545 85.701V78.701Z",
    fill: "#122431"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.045 81.701C62.978 81.701 64.545 80.134 64.545 78.201C64.545 76.2681 62.978 74.701 61.045 74.701C59.112 74.701 57.545 76.2681 57.545 78.201C57.545 80.134 59.112 81.701 61.045 81.701Z",
    fill: "#FEFFFF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.025 113.271L28.225 111.021C29.135 109.321 31.375 108.661 32.935 109.801C33.045 109.881 36.175 115.691 38.465 117.431C40.985 119.341 45.975 119.571 50.365 115.361C56.185 109.781 56.885 101.001 60.865 97.4911C67.855 91.3211 76.285 92.3411 82.125 97.4111C87.965 102.481 89.165 111.881 85.025 118.471C80.905 125.041 66.335 132.841 58.905 134.961C49.785 137.561 40.695 133.371 36.705 130.311C30.325 125.441 26.095 117.941 26.095 117.941C24.315 116.201 25.525 114.331 27.035 113.271H27.025Z",
    fill: "url(#paint6_linear_0_1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 26.605,
    y: 101.789,
    width: 112.181,
    height: 102.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 17.655,
    y: 27.321,
    width: 123,
    height: 120.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 65.19,
    y: 31,
    width: 26.3538,
    height: 27.3837,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 17.2094,
    y: 88.2288,
    width: 78.2653,
    height: 58.5468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 82.7042,
    y1: 106.802,
    x2: 82.703,
    y2: 193.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 127.918,
    y1: 117.759,
    x2: 127.918,
    y2: 162.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 32.1319,
    y1: 125.013,
    x2: 47.3984,
    y2: 94.4596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 48.305,
    y1: 75.1011,
    x2: 5.65497,
    y2: 75.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 110.005,
    y1: 75.1011,
    x2: 152.655,
    y2: 75.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 79.155,
    y1: 136.401,
    x2: 79.155,
    y2: 32.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 82.7601,
    y1: 97.754,
    x2: 34.5026,
    y2: 130.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.3b94b3facc95cd79849a840840e616f1.svg";
export { ForwardRef as ReactComponent };